/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Box, Divider } from '@material-ui/core';
import { DefectTypesMap } from 'app/consumer-app/views/report-fault/report-fault-utils';
import { productImg } from 'app/core/api/product-assignment/api-product-assignment.types';
import { useRepairerCase } from 'app/core/api/repairer/api-repairer';
import { getOtherUsersName } from 'app/core/api/user/user-utils';
import { appEnv, AppVariant } from 'app/core/environment';
import { useSetPageTitle } from 'app/shared/context-hooks/use-titlebar.hook';
import styledFuncs from 'app/styles/styledFuncs';
import styledMixins from 'app/styles/styledMixins';
import { useUrlParams } from 'app/tools/hooks/misc-hooks';
import Form from 'app/shared/frames/Form';
import React, { useState, useEffect } from 'react';
import styled, { css } from 'styled-components/macro';
import { useShowInfo } from 'app/shared/context-hooks/use-show-info.hook';
import useInputForm from 'app/shared/components/form-input/utilities/use-input-form';
// import FormSelectInput from 'app/shared/components/form-input/FormSelectInput';
import FormTextInput from 'app/shared/components/form-input/FormTextInput';
import {
  GENERAL_MAX_LENGTH,
  maxLengthRule,
} from 'app/shared/components/form-input/utilities/form-tools';
import Button from 'app/shared/components/button/Button';
import { useCreateRepairCaseWarrantyCovered } from 'app/core/api/warranty-covered/api-warranty-covered';
import {
  WarrantyCoveredInput,
  WarrantyCoveredReq,
} from 'app/core/api/warranty-covered/api-warranty-covered.types';
import { FrameContentsInner } from '../../frames/ViewFrame';
// import Subheading from '../../components/typography/subheading/Subheading';
import {
  DefaultUserImg,
  PadCollapse,
  InputTitle,
} from '../../components/misc';
import Body from '../../components/typography/body/Body';
import IconLib, {
  IWRepairerSvg,
} from '../../components/icon/icon-lib';
import Icon from '../../components/icon/Icon';
import ProductPictureOrDefault from '../../components/app-image/ProductPictureOrDefault';
import AppImage from '../../components/app-image/AppImage';

const imgHeight = 80;

const ProductPicture = styled(ProductPictureOrDefault)`
  width: 100px;
  padding: 0;
  justify-content: center;
  text-align: center;
  display: block;
`;
const Table = styled.table`
  border-collapse: separate;
  table-layout: fixed;
  text-align: center;
  th {
    color: #31ad31;
    font-size: 16px;
    font-weight: 500;
  }
  td {
    margin: 5px auto;
  }
`;
const StandardImage = styled(AppImage)`
  ${styledMixins.roundCorners}
  ${styledMixins.roundCorners}
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: ${imgHeight}px;
  width: ${imgHeight}px;
  min-width: ${imgHeight * 0.8}px;
  flex-shrink: 10000;
  padding: 0;
`;

type InfoLineProps = { icon: IconLib; value: string };
const InfoLine: React.VFC<InfoLineProps> = ({ icon, value }) => (
  <div
    css={css`
      display: flex;
      align-items: center;
      margin-bottom: ${styledFuncs.pad(0.5)};
      margin-left: ${styledFuncs.pad(0.5)};
      > * {
        margin-left: ${styledFuncs.pad()};
        overflow-wrap: anywhere;
        flex: 0 1 auto;
      }
    `}
  >
    <Icon {...{ icon }} size={16} />
    <Body>{value}</Body>
  </div>
);

const DetailsTitle = styled(Body)`
  font-weight: 400;
  font-size: 15px;
  color: #31ad31;
  + * {
    margin: ${styledFuncs.pad(0.5)} ${styledFuncs.pad(1.5)} 0;
  }
`;

// const DetailData = styled(Body)`
//   font-weight: 500;
//   font-size: 13px;
//   color: #000000;
//   + * {
//     margin: ${styledFuncs.pad(0.5)} ${styledFuncs.pad(1.5)} 0;
//   }
// `;

const rules = maxLengthRule(GENERAL_MAX_LENGTH);
const warrantyOptions = [
  'Fully Covered',
  'Partially Covered',
  'Not Covered',
  'Further Inspection Required',
  'Not Applicable',
];
export default function TaskInfo(): JSX.Element {
  const { id } = useUrlParams(['id']);
  const { resource: repairCase, loadingMissing } =
    useRepairerCase(id);
  const { showSnack } = useShowInfo();
  // const titleMsg = loadingMissing ? 'Loading...' : `Task Info`;
  const [warrantyCoverage, setWarrantyCoverage] = useState(
    warrantyOptions[4]
  );
  // useSetPageTitle(titleMsg);
  const otherUserName =
    getOtherUsersName(repairCase) ||
    (appEnv.APP_VARIANT === AppVariant.CONSUMER ? 'Case' : 'Job');

  useSetPageTitle(`${otherUserName}`);

  const {
    request$: createWarrantyCovered$,
    sending: createWarrantyCoverage,
  } = useCreateRepairCaseWarrantyCovered();

  const { repairerDetails, productDefectDetails } = repairCase || {};
  const { assignedProductDetails } = productDefectDetails || {};
  const { productDetails } = assignedProductDetails || {};
  const issueType =
    DefectTypesMap.get(productDefectDetails?.title) ||
    productDefectDetails?.title;

  const isConsumer = appEnv.APP_VARIANT === AppVariant.CONSUMER;
  const otherUsersName = getOtherUsersName(repairCase);

  const otherUsersImg = isConsumer ? (
    <StandardImage
      alt="repairer profile"
      src={repairerDetails?.logo}
      pendingSrc={loadingMissing}
      fallbackImgNode={<IWRepairerSvg width={imgHeight} />}
    />
  ) : (
    <DefaultUserImg size={imgHeight} />
  );

  // const WarrantyCoveredContainer = styled.div`
  //   padding-top: 1px;
  //   p {
  //     width: 40%;
  //     float: left;
  //     padding-top: 15px;
  //     font-size: 13px;
  //   }
  //   .MuiFormControl-root {
  //     width: 100%;
  //   }
  // `;
  const DetailsContainer = styled.div`
    margin: 0;
    p {
      padding-bottom: 10px;
    }
  `;
  const DetailsDesc = styled.div`
    padding: 17px 10px;
    margin: 0;
    height: 57px;
    display: table;
    vertical-align: middle;
    width: 100%;
    background: #ffffff;
    border: 1px solid #a8a8a8;
    border-radius: 10px;
    overflow-wrap: break-word;
  `;

  const consumerInfo = [
    { icon: IconLib.USER, value: otherUsersName },
  ];
  const repairerInfo = [
    { icon: IconLib.USER, value: otherUsersName },
    { icon: IconLib.HOME, value: repairerDetails?.website },
    { icon: IconLib.PHONE, value: repairerDetails?.phone },
  ];

  const otherUsersInfo = isConsumer ? repairerInfo : consumerInfo;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const { handleSubmit, inputProps, setValue } =
    useInputForm<WarrantyCoveredInput>({});

  useEffect(() => {
    setValue('warrantyCovered', warrantyCoverage);
  }, [warrantyCoverage, setValue]);

  useEffect(() => {
    setWarrantyCoverage(warrantyCoverage);
  }, [warrantyCoverage, setWarrantyCoverage]);

  useEffect(() => {
    // if (repairCase?.warrantyCovered) {
    //   setValue('warrantyCovered', 'true');
    //   setWarrantyCoverage('true');
    // } else {
    //   setValue('warrantyCovered', 'false');
    //   setWarrantyCoverage('false');
    // }
    setValue('additionalComment', repairCase?.additionalComment);
  }, [repairCase, setValue]);

  // const handleWarrantyCoverage = (
  //   event: React.ChangeEvent<{ value: unknown }>
  // ) => {
  //   setValue('warrantyCovered', event.target.value as string);
  //   setWarrantyCoverage(event.target.value as string);
  // };

  const onSubmit = (formValues: WarrantyCoveredInput) => {
    const warrantyCoveredReq: WarrantyCoveredReq = {
      repaircaseId: repairCase?.id,
      warrantyCovered: warrantyCoverage,
      repairerComments: repairCase?.repairerComments,
      additionalComment: formValues.additionalComment ?? '',
    };
    createWarrantyCovered$(warrantyCoveredReq).subscribe(() => {
      // setValue('warrantyCovered', 'false');
      // setWarrantyCoverage('false');
      // setValue('repairerComments', '');
      showSnack({
        message: `Information successfully submitted!`,
      });
    });
  };

  return (
    <FrameContentsInner>
      <PadCollapse pad={0} />
      <Box display="none">
        {otherUsersImg}
        <Box display="flex" flexDirection="column">
          {otherUsersInfo.map(
            ({ icon, value }) =>
              value && <InfoLine {...{ icon, value }} key={icon} />
          )}
        </Box>
      </Box>
      {/* <Divider /> */}
      {/* <Subheading centered={false}>Product Defect Details</Subheading> */}
      <div style={{ display: 'block', margin: '20px' }}>
        <ProductPicture
          pendingSrc={loadingMissing}
          productId={productDetails?.id}
          src={productImg(assignedProductDetails)}
          height={`${imgHeight}px`}
          css={{ margin: '0 auto' }}
        />
      </div>
      <Table style={{ display: 'none' }}>
        <thead>
          <th>Product Name</th>
          <th>Issue Type</th>
        </thead>
        <tr>
          <td>{productDetails?.name}</td>
          <td>{issueType}</td>
        </tr>
      </Table>
      <div
        style={{
          display: 'flex',
          alignItems: 'stretch',
        }}
      >
        <div style={{ width: '48%', textAlign: 'center' }}>
          <DetailsTitle>Product Name</DetailsTitle>
          <DetailsTitle style={{ color: '#000' }}>
            {productDetails?.name}
          </DetailsTitle>
        </div>
        <div style={{ width: '1%' }}>
          <Divider
            orientation="vertical"
            flexItem
            style={{
              height: '100%',
              width: '1px',
              backgroundColor: '#000000',
            }}
          />
        </div>
        <div style={{ width: '48%', textAlign: 'center' }}>
          <DetailsTitle>Issue Type</DetailsTitle>
          <DetailsTitle style={{ color: '#000' }}>
            {issueType}
          </DetailsTitle>
        </div>
      </div>
      <DetailsContainer>
        <DetailsTitle style={{ color: '#31ad31' }}>
          User description
        </DetailsTitle>
        <DetailsDesc>{productDefectDetails?.description}</DetailsDesc>
      </DetailsContainer>
      {repairCase?.diagnosisComment && (
        <DetailsContainer>
          <DetailsTitle style={{ color: '#31ad31' }}>
            Diagnosis comments
          </DetailsTitle>
          <DetailsDesc>{repairCase?.diagnosisComment}</DetailsDesc>
        </DetailsContainer>
      )}
      {repairCase?.repairerComments && (
        <DetailsContainer>
          <DetailsTitle style={{ color: '#31ad31' }}>
            Repair comments
          </DetailsTitle>
          <DetailsDesc>{repairCase?.repairerComments}</DetailsDesc>
        </DetailsContainer>
      )}
      {isConsumer && (
        <>
          {repairCase?.additionalComment && (
            <DetailsContainer>
              <DetailsTitle>Additional Comments</DetailsTitle>
              <DetailsDesc>
                {repairCase?.additionalComment}
              </DetailsDesc>
            </DetailsContainer>
          )}
          <DetailsContainer>
            <DetailsTitle>Repair Comments</DetailsTitle>
            <DetailsDesc>{repairCase?.repairerComments}</DetailsDesc>
          </DetailsContainer>
          {/* {repairCase?.warrantyCovered && (
            <DetailsContainer>
              <DetailsTitle>
                Warranty Coverage <Body small>(coming soon)</Body>{' '}
              </DetailsTitle>
              <DetailsDesc>{repairCase?.warrantyCovered}</DetailsDesc>
            </DetailsContainer>
          )} */}
        </>
      )}
      {!isConsumer && (
        <Form onSubmit={handleSubmit(onSubmit)}>
          {/* <WarrantyCoveredContainer>
            <InputTitle
              style={{
                fontSize: '15px',
                color: '#31ad31',
                fontWeight: 400,
                paddingTop: '0',
                paddingBottom: '10px',
              }}
            >
              Warranty Coverage
            </InputTitle>
            <FormSelectInput
              optional
              classicPlaceholder
              controlName="warrantyCovered"
              value={warrantyCoverage}
              onChange={handleWarrantyCoverage}
              disabled
              {...inputProps}
            >
              {warrantyOptions.map(value => (
                <MenuItem key={value} value={value}>
                  {value}
                </MenuItem>
              ))}           
            </FormSelectInput>
          </WarrantyCoveredContainer> */}
          <InputTitle
            style={{
              fontSize: '15px',
              color: '#31ad31',
              fontWeight: 400,
            }}
          >
            Additional Comments
          </InputTitle>
          <FormTextInput
            optional
            classicPlaceholder
            controlName="additionalComment"
            placeholder="Additional comments..."
            multiline
            // minRows={1}
            // maxRows={1}
            minHeight={57}
            style={{
              fontSize: '13px',
              // height: '40px',
              padding: 0,
            }}
            {...{ rules }}
            {...inputProps}
          />

          <Box position="relative">
            <Button
              type="submit"
              variant="outlined"
              size="medium"
              pending={createWarrantyCoverage}
              style={{
                float: 'right',
                minHeight: '40px',
                padding: '0 25px',
              }}
            >
              Submit
            </Button>
          </Box>
        </Form>
      )}
    </FrameContentsInner>
  );
}
